




















































import FormInput from "@/components/FormInput.vue";
import FormCheckbox from "@/components/FormCheckbox.vue";
import FormInputError from "@/components/FormInputError.vue";
import { ConsultationRequest } from "@/types/consultation";
import FormValidation from "@/mixins/form-validation";
import { Component, Mixins } from "vue-property-decorator";

@Component({ components: { FormInput, FormCheckbox, FormInputError } })
export default class ConsultingView extends Mixins(FormValidation) {
  initialRequest: ConsultationRequest = {
    email: "",
    questions: [
      "What stack/framework are you using? (e.g., Rails, Django, ...)",
      "What are you caching?",
      "What is the main reason you are using a cache?",
      "What is your biggest pain point when implementing/using caching?",
    ],
    answers: [],
    consent: true,
  };

  request = this.initialRequest;

  title = "Send";

  isSending = false;

  emailError = "";
  answersError = "";
  consentError = "";

  sendRequest() {
    this.emailError = this.validateEmail(this.request.email);
    if (this.emailError) return;

    this.answersError = this.validateAnswers();
    if (this.answersError) return;

    this.consentError = this.validateConsent();
    if (this.consentError) return;

    this.$ga.button("Send consultation request");

    this.title = "Sending";
    this.isSending = true;

    this.$store.dispatch("sendConsultationRequest", this.request).then(() => {
      this.title = "Sent!";
      this.isSending = false;
      setTimeout(() => {
        this.title = "Send";
        this.request = this.initialRequest;
      }, 1000);
    });
  }

  validateAnswers(): string {
    for (let i = 0; i < this.request.questions.length; i++) {
      if (!this.request.answers[i]) {
        return "An answer is required for each question";
      }
    }
    return "";
  }

  validateConsent(): string {
    if (this.request.consent) {
      return "";
    }
    return "Without reviewing your cache we will not be able to provide useful insight";
  }
}
